// eslint-disable-next-line import/prefer-default-export
export const isAnnotSupported = type =>
  type === "Tx" || type === "Btn" || type === "Ch";
